import React, { useEffect, useState } from "react";
import axios from 'axios';
import Orders from "../order/orders/orders.jsx";

const Chuyenxu = () => {
  return (
    <>
      <div className="mx-2 flex justify-center items-center space-x-2">
        <div>
          <p>Nếu dùng tính năng này thì bạn sẽ bị hạn chế rút trong hôm nay</p>
        </div>
        <a href="/shop/transaction?app=showadview" className="btn btn-sm btn-primary">Lịch sử chuyển coin</a>
      </div>

      <Orders category_main='transfer_coins' />
    </>
  );
};

export default Chuyenxu;